/**
 * Segments de `/mes-devis/…` qui sont des pages, pas des identifiants de
 * proposition. Les prendre pour un identifiant enverrait le visiteur sur le mur
 * du nom d'un devis qui ne peut pas exister.
 */
const MES_DEVIS_PAGES = new Set(['nouvelle-demande'])

/**
 * Équivalent public d'une page du compte, s'il en existe un.
 *
 * Un client qui arrive d'un mail n'a aucune raison de tomber sur un écran de
 * connexion : ce qu'il vient voir a une page publique, derrière le mur du nom.
 * L'envoyer se connecter d'abord, c'est lui demander un mot de passe qu'il n'a
 * peut-être jamais créé pour lire un devis qu'on lui a envoyé
 * (ACCES-PERSO-REDIRECT).
 *
 * Le fragment n'atteint jamais le serveur, mais la garde qui appelle ceci
 * s'exécute dans le navigateur : il est lisible. Nos propres liens y ont
 * toujours mis un identifiant de DEMANDE — les liens de proposition, eux,
 * passent par le chemin.
 */
export function publicEquivalent(pathname: string, hash: string): null | string {
  const responseId = /^\/mes-devis\/([^/]+)/.exec(pathname)?.[1]
  if (responseId && !MES_DEVIS_PAGES.has(responseId)) return `/devis/${responseId}`

  const estimateId = hash.replace(/^#/, '')
  if (pathname === '/mes-devis' && estimateId) return `/demande/${estimateId}`

  return null
}
